exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ticketType_0 {\n  margin: 2px 2px;\n  padding: 0 5px;\n  background: #efefef;\n  border-radius:5px;\n  display: inline-block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10aa3182","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/setting/TicketTypeParent.vue
// module id = 690
// module chunks = 75